import { useSelector } from 'react-redux';
import Context from '@alltrails/types/Context';

export default function usePublicBaseUrl() {
  // Default to an empty string to avoid errors when context is not provided in the redux store
  return useSelector((state: { context: Context }) => state.context?.publicBaseUrl ?? '');
}
